import { Injectable } from '@angular/core';
import { RequestService } from '@core/services/request/request.service';
import { Observable } from 'rxjs';
import { RequestResponse } from '@core/services/request/model/request.model';
import { ApiDirectory } from '@core/api/api-directory';
import { HomeMyServicesApi } from '@core/api/model/home/home-my-services-api.model';
import { HomeMyInvoicesApi } from '@core/api/model/home/home-my-invoices-api.model';
import { HttpEvent } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ApiHomeService {
  constructor(private readonly requestService: RequestService) {}

  /**
   * Fetch my services for the home page
   */
  public fetchMyServices(loading?: boolean | string): Observable<RequestResponse<HomeMyServicesApi>> {
    return this.requestService.get(ApiDirectory.Home.ServiciosContratados({}), {
      loading,
    });
  }

  /**
   * Fetch my last 4 invoices
   */
  public fetchMyInvoices(loading?: boolean | string): Observable<RequestResponse<HomeMyInvoicesApi>> {
    return this.requestService.get(ApiDirectory.Home.UltimasFacturas({}), {
      loading,
    });
  }

  public downloadConsumerArbitrationDocument(): Observable<HttpEvent<Blob>> {
    return this.requestService.downloadWithProgress(ApiDirectory.Home.SistemaArbitralDeConsumo({}));
  }
}
